import { get, postJson } from '../httpClient';

/**
 * Calendar participants and invitations.
 *
 * Search only ever reads the organizer's own audience, on the server, so the
 * three-tier rule (team, evidenced relationship, plain contact) is applied in
 * one place: server/api-util/calendarInvites.js. Invitations for org events
 * go out as part of saving the events; a creator's are requested here after
 * the event is on their profile.
 */
export const calendarInvitesAPI = {
  /** GET /api/creator/calendar/participants?q= */
  searchCreatorParticipants: q => get('/api/creator/calendar/participants', { q }),

  /** GET /api/org/:orgId/calendar/participants?q= */
  searchOrgParticipants: (orgId, q) => get(`/api/org/${orgId}/calendar/participants`, { q }),

  /** POST /api/creator/calendar-events/:eventId/invites */
  sendCreatorInvites: eventId => postJson(`/api/creator/calendar-events/${eventId}/invites`),
};
